<div class="backdrop" [class.blurred]="isBlurred" [class.shadowed]="isShadowed"></div>
<div class="spinner-wrapper">
  <mat-spinner [color]="color"></mat-spinner>
</div>
